import React from 'react';
import { FileTextIcon, VideoIcon, BookOpenIcon, DownloadIcon, FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, CalendarIcon, UsersIcon, GlobeIcon, ClockIcon, MapPinIcon, ExternalLinkIcon } from 'lucide-react';
export function Resources() {
  const resourceCategories = [{
    icon: FileTextIcon,
    title: 'Slide Decks & Manuals',
    description: 'Detailed presentation PDFs for each certification course and workshop',
    items: ['Master Tung Acupuncture Complete Manual', 'Balance Method Training Slides', 'Scalp Acupuncture Protocol Guide', 'Cosmetic Acupuncture Techniques', 'Fertility Treatment Protocols']
  }, {
    icon: BookOpenIcon,
    title: 'Case Study Compendium',
    description: 'Downloadable treatment protocols and outcome data for major conditions',
    items: ['Chronic Pain Management Cases', 'Stroke Recovery Protocols', 'Fertility Success Stories', 'Diabetes Management Outcomes', 'Neurological Rehabilitation Cases']
  }, {
    icon: DownloadIcon,
    title: 'Patient Self-Care Guides',
    description: 'Nutritional charts, acupressure maps, and lifestyle modification booklets',
    items: ['TCM Dietary Therapy Guide', 'Acupressure Point Maps', 'Seasonal Wellness Calendar', 'Stress Management Techniques', 'Sleep Optimization Protocol']
  }, {
    icon: VideoIcon,
    title: 'Video Tutorials & Webinars',
    description: 'Recorded lectures, demonstrations, and Q&A sessions',
    items: ['Master Tung Point Location Videos', 'Tongue Diagnosis Webinar Series', 'Pulse Assessment Techniques', 'Treatment Demonstration Videos', 'Clinical Case Discussions']
  }];
  const socialChannels = [{
    icon: YoutubeIcon,
    name: 'YouTube',
    handle: '@aiimraethe',
    description: 'Video tutorials and recorded lectures',
    link: 'https://www.youtube.com/@aiimraethe',
    color: 'red'
  }, {
    icon: FacebookIcon,
    name: 'Facebook',
    handle: 'Aatmshakti Empowerment Trust',
    description: 'Community updates and health tips',
    link: '#',
    color: 'blue'
  }, {
    icon: InstagramIcon,
    name: 'Instagram',
    handle: '@aiimraethe',
    description: 'Daily wellness tips and clinic highlights',
    link: '#',
    color: 'pink'
  }, {
    icon: LinkedinIcon,
    name: 'LinkedIn',
    handle: 'AIIMR Integrative Medicine Community',
    description: 'Professional networking and articles',
    link: '#',
    color: 'indigo'
  }];
  return <div className="w-full bg-white" data-id="element-817">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-818">
        <div className="max-w-7xl mx-auto text-center" data-id="element-819">
          <BookOpenIcon className="w-16 h-16 text-blue-600 mx-auto mb-6" data-id="element-820" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-821">
            Resource Library
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-822">
            Access a wealth of downloadable materials, multimedia resources, and
            educational content
          </p>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-823">
        <div className="max-w-7xl mx-auto" data-id="element-824">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-825">
            Educational Materials
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-826">
            {resourceCategories.map((category, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-827">
                <div className="flex items-start mb-4" data-id="element-828">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-829">
                    <category.icon className="w-6 h-6 text-blue-600" data-id="element-830" />
                  </div>
                  <div data-id="element-831">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-832">
                      {category.title}
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-833">
                      {category.description}
                    </p>
                  </div>
                </div>
                <ul className="space-y-2 mt-4" data-id="element-834">
                  {category.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-center text-sm text-gray-700" data-id="element-835">
                      <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-3 flex-shrink-0" data-id="element-836"></div>
                      <span data-id="element-837">{item}</span>
                    </li>)}
                </ul>
                <button className="mt-6 w-full bg-blue-50 text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-100 transition-colors flex items-center justify-center" data-id="element-838">
                  <DownloadIcon className="w-5 h-5 mr-2" data-id="element-839" />
                  Access Resources
                </button>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gray-50 w-full" data-id="element-840">
        <div className="max-w-7xl mx-auto" data-id="element-841">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-842">
            Research Paper Repository
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12" data-id="element-843">
            Access published articles, conference proceedings, and journal
            papers on integrative medicine and Traditional Chinese Medicine
          </p>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-844">
            <div className="bg-white p-6 rounded-xl shadow-lg text-center" data-id="element-845">
              <FileTextIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-846" />
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-847">
                Published Articles
              </h3>
              <p className="text-sm text-gray-600 mb-4" data-id="element-848">
                Peer-reviewed research papers
              </p>
              <button className="text-blue-600 font-medium hover:underline" data-id="element-849">
                Browse Articles
              </button>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center" data-id="element-850">
              <BookOpenIcon className="w-12 h-12 text-teal-600 mx-auto mb-4" data-id="element-851" />
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-852">
                Conference Proceedings
              </h3>
              <p className="text-sm text-gray-600 mb-4" data-id="element-853">
                Symposium presentations and abstracts
              </p>
              <button className="text-teal-600 font-medium hover:underline" data-id="element-854">
                View Proceedings
              </button>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center" data-id="element-855">
              <GlobeIcon className="w-12 h-12 text-purple-600 mx-auto mb-4" data-id="element-856" />
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-857">
                Journal Papers
              </h3>
              <p className="text-sm text-gray-600 mb-4" data-id="element-858">
                Clinical studies and research findings
              </p>
              <button className="text-purple-600 font-medium hover:underline" data-id="element-859">
                Access Journals
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-860">
        <div className="max-w-7xl mx-auto" data-id="element-861">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-862">
            Connect With Us
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-863">
            {socialChannels.map((channel, index) => <a key={index} href={channel.link} target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center" data-id="element-864">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-865">
                  <channel.icon className={`w-8 h-8 text-${channel.color}-600`} data-id="element-866" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-867">
                  {channel.name}
                </h3>
                <p className="text-sm text-gray-600 mb-2" data-id="element-868">{channel.handle}</p>
                <p className="text-xs text-gray-500" data-id="element-869">{channel.description}</p>
              </a>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-blue-50 to-teal-50 w-full" data-id="element-870">
        <div className="max-w-7xl mx-auto" data-id="element-871">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-872">
            Regular Events & Webinars
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-873">
            <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-874">
              <div className="flex items-center mb-6" data-id="element-875">
                <VideoIcon className="w-12 h-12 text-blue-600 mr-4" data-id="element-876" />
                <div data-id="element-877">
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-878">
                    TCM Tongue Diagnosis Webinar Series
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-879">Monthly Live Sessions</p>
                </div>
              </div>
              <div className="space-y-4 mb-6" data-id="element-880">
                <div className="flex items-start" data-id="element-881">
                  <CalendarIcon className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-882" />
                  <div data-id="element-883">
                    <p className="font-semibold text-gray-900" data-id="element-884">Schedule</p>
                    <p className="text-sm text-gray-600" data-id="element-885">
                      First Saturday of every month, 5:00–6:30 PM IST
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-886">
                  <ClockIcon className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-887" />
                  <div data-id="element-888">
                    <p className="font-semibold text-gray-900" data-id="element-889">Format</p>
                    <p className="text-sm text-gray-600" data-id="element-890">
                      Live online demonstration, case reviews, and interactive
                      Q&A
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg mb-6" data-id="element-891">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-892">
                  Monthly Topics:
                </h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-893">
                  <li className="flex items-start" data-id="element-894">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-895"></div>
                    <span data-id="element-896">
                      Month 1: Basics of Tongue Anatomy & Pattern
                      Differentiation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-897">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-898"></div>
                    <span data-id="element-899">
                      Month 2: Tongue Coating Analysis and Internal Heat
                      Syndromes
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-900">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-901"></div>
                    <span data-id="element-902">Month 3: Fluid Imbalance & Dryness Patterns</span>
                  </li>
                  <li className="flex items-start" data-id="element-903">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-904"></div>
                    <span data-id="element-905">
                      Month 4: Phlegm, Stagnation, & Blood Stasis Indicators
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-906">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-907"></div>
                    <span data-id="element-908">
                      Rotating Advanced Case Studies and Guest Expert Sessions
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-909">
                <p className="text-sm text-gray-700 mb-2" data-id="element-910">
                  <span className="font-semibold" data-id="element-911">Registration:</span> Free for
                  AIIMR alumni; ₹500 for external practitioners
                </p>
              </div>
              <button className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-912">
                Register for Next Webinar
              </button>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-913">
              <div className="flex items-center mb-6" data-id="element-914">
                <UsersIcon className="w-12 h-12 text-teal-600 mr-4" data-id="element-915" />
                <div data-id="element-916">
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-917">
                    Quarterly Integrative Medicine Symposium
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-918">Major Annual Event</p>
                </div>
              </div>
              <div className="space-y-4 mb-6" data-id="element-919">
                <div className="flex items-start" data-id="element-920">
                  <CalendarIcon className="w-5 h-5 text-teal-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-921" />
                  <div data-id="element-922">
                    <p className="font-semibold text-gray-900" data-id="element-923">Next Event</p>
                    <p className="text-sm text-gray-600" data-id="element-924">December 2025</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-925">
                  <MapPinIcon className="w-5 h-5 text-teal-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-926" />
                  <div data-id="element-927">
                    <p className="font-semibold text-gray-900" data-id="element-928">Location</p>
                    <p className="text-sm text-gray-600" data-id="element-929">
                      AIIMR Campus, Lucknow & Virtual Access
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-teal-50 p-4 rounded-lg mb-6" data-id="element-930">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-931">Features:</h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-932">
                  <li className="flex items-start" data-id="element-933">
                    <div className="w-1.5 h-1.5 bg-teal-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-934"></div>
                    <span data-id="element-935">
                      Keynote lectures by Dr. Amit Kapoor and international TCM
                      experts
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-936">
                    <div className="w-1.5 h-1.5 bg-teal-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-937"></div>
                    <span data-id="element-938">
                      Panel discussions on integrative oncology, metabolic
                      disorders, and mental health
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-939">
                    <div className="w-1.5 h-1.5 bg-teal-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-940"></div>
                    <span data-id="element-941">
                      Hands-on breakout workshops in Master Tung, Balance
                      Method, and Scalp Acupuncture
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-942">
                    <div className="w-1.5 h-1.5 bg-teal-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-943"></div>
                    <span data-id="element-944">
                      Networking opportunities with leading practitioners
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-945">
                    <div className="w-1.5 h-1.5 bg-teal-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-946"></div>
                    <span data-id="element-947">Continuing education credits available</span>
                  </li>
                </ul>
              </div>
              <button className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors" data-id="element-948">
                Learn More About Symposium
              </button>
            </div>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-xl text-center" data-id="element-949">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-950">
              Stay Informed About Upcoming Events
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-951">
              Subscribe to receive notifications about webinars, symposiums, and
              special training opportunities
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-952">
              <input type="email" placeholder="Enter your email" className="flex-1 px-6 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:border-blue-500" data-id="element-953" />
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-954">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}